import { Reveal, SectionHeading } from "@/components/Reveal";
import { useLang } from "@/i18n/translations";

export const Industries = () => {
  const { t } = useLang();
  return (
    <section id="branchen" data-testid="industries-section" className="relative py-20 sm:py-28 bg-[#070a12] border-y border-white/5">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-10">
        <SectionHeading kicker={t.industries.kicker} title={t.industries.title} subtitle={t.industries.subtitle} testId="industries-heading" />
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {t.industries.items.map((item, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div
                data-testid={`industry-card-${i}`}
                className="group rounded-xl border border-white/10 bg-white/[0.02] px-6 py-5 flex items-center justify-between hover:border-[rgba(167,243,255,0.3)] hover:bg-white/[0.04] transition-[border-color,background-color] duration-300"
              >
                <span className="font-display text-base font-medium text-foreground">{item.name}</span>
                <span className="text-[10px] font-mono-cs text-muted-foreground/70 group-hover:text-[#00d4ff] transition-colors duration-300 text-right">
                  {item.project}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
